import { toast } from "../lib/toast";
import { stringToArray } from "./array";

export function capitalize(value: string) {
  let capitalizedText = "";
  const conjunctions = [
    "an",
    "a",
    "the",
    "of",
    "and",
    "but",
    "for",
    "nor",
    "or",
    "so",
    "yet",
    "in",
    "on",
    "at",
    "to",
    "by",
    "with",
  ];

  const textArray = value?.split(" ");

  for (let i = 0; i < textArray?.length; i++) {
    let word = textArray[i];
    if (i === 0 || word?.endsWith(".")) {
      capitalizedText +=
        word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase() + " ";
    } else if (conjunctions?.includes(word?.toLowerCase())) {
      capitalizedText += word?.toLowerCase() + " ";
    } else {
      capitalizedText +=
        word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase() + " ";
    }
  }

  return capitalizedText?.trim();
}

export function returnFirstChar(value: string) {
  return value?.charAt(0)?.toUpperCase();
}

export function removeQuotesFromText(input: string) {
  return input?.replace(/"/g, "");
}

export function sliceUrl(str: string = "", size: number, dot?: string) {
  const splitStr = str?.split(".");
  splitStr.pop();
  const newStr = splitStr?.join();

  return newStr?.length > size
    ? `${newStr?.slice(0, size)}${dot || ""}`
    : newStr;
}

export const getExtension = (url: string) => {
  const file = stringToArray(url, ".") as string[];
  return file?.[file?.length - 1]?.toLowerCase();
};

export function formatUrl(url?: string): string | undefined {
  if (!url) return undefined;

  if (url.startsWith("http://") || url.startsWith("https://")) {
    return url;
  }
  return `https://${url}`;
}

export function parseJSON(val: string) {
  try {
    return JSON.parse(val);
  } catch (error) {
    toast("error", "JSON parse fail");
    return null;
  }
}

export function valueOrNa(val: any) {
  return val || "N/A";
}

// utils/cn.ts
type ClassValue =
  | string
  | number
  | null
  | undefined
  | ClassDictionary
  | ClassArray;
interface ClassDictionary {
  [id: string]: any;
}
interface ClassArray extends Array<ClassValue> {}

export function cn(...args: ClassValue[]): string {
  const classes: string[] = [];

  for (const arg of args) {
    if (!arg) continue;

    if (typeof arg === "string" || typeof arg === "number") {
      classes.push(String(arg));
    } else if (Array.isArray(arg)) {
      if (arg.length) {
        const inner = cn(...arg);
        if (inner) classes.push(inner);
      }
    } else if (typeof arg === "object") {
      for (const [key, value] of Object.entries(arg)) {
        if (value) {
          classes.push(key);
        }
      }
    }
  }

  return classes.join(" ");
}

export function formatBDMobile(mobile: string): string | null {
  if (!mobile) return null;

  // Remove all non-digit characters
  let normalized = mobile.replace(/\D/g, "");

  // Remove leading 0 or 880
  if (normalized.startsWith("0")) {
    normalized = normalized.slice(1);
  } else if (normalized.startsWith("880")) {
    normalized = normalized.slice(3);
  }

  // Check valid BD operator code
  const validOperators = /^(13|14|15|16|17|18|19)/;
  if (!validOperators.test(normalized) || normalized.length !== 10) {
    return null;
  }

  // Format: +880 17 1234-5678
  const formatted = `+880 ${normalized.slice(0, 4)}-${normalized.slice(4)}`;

  return formatted;
}

